import APIService from "@/services/APIService";
import JSONApiService from "@/services/JSONApiService";
import { BOOKING_TEMPLATE_MODEL } from "@/models/booking-template-model";
import { FIELD_NECESSITY_MODEL } from "@/models/field-necessity-model";
import { GRADE_MODEL } from "@/models/grade-model";
import {
  include,
  TEMPLATE_PAY_RATES,
  TEMPLATE_PAY_RATES_ITEMS,
  DATA,
  CATEGORY,
  CONTRACT_TYPES_GROUPINGS,
  WORKING_HOURS_GROUPINGS
} from "@/models/relationships";
import { hireReasonEndpoints } from "@/models/hire-reason-model";
import { disablePluralizeForCall } from "@/services/utils";
import { ADDRESS_MODEL } from "@/models/address-model";
import { COUNTRY_MODEL } from "@/models/country-model";
import { PUBLISHING_SCHEDULE_TAG } from "@/models/tag-model";
import { COST_CATEGORY } from "@/models/cost-category-model";
import { SEXUAL_ORIENTATION_MODEL } from "@/models/sexual-orientation-model";
import { RELIGION_MODEL } from "@/models/religion-model";
import { MARITAL_STATUS_MODEL } from "@/models/marital-status-model";
import { LOCATION_GROUPING_MODEL } from "@/models/location-grouping-model";
import { ETHNIC_GROUP_MODEL } from "@/models/ethnic-group-model";
import { CONTRACT_TYPE_MODEL } from "@/models/contract-type-model";
import { COMMENT_MODEL } from "@/models/comment-model";
import { EXPERIENCE_FUNCTION_MODEL } from "@/models/experience-function-model";
import { TAXONOMY_MODEL } from "@/models/taxonomy-model";
import { WORKING_HOURS_MODEL } from "@/models/working-hours-model";
import pluralize from "pluralize";

const dataApi = commit => ({
  getBookingTemplates: params =>
    JSONApiService(commit)
      .all(BOOKING_TEMPLATE_MODEL)
      .get(params),
  getBookingTemplate: id =>
    JSONApiService(commit)
      .one(BOOKING_TEMPLATE_MODEL, id)
      .get(include(TEMPLATE_PAY_RATES, TEMPLATE_PAY_RATES_ITEMS)),
  getLocations: params =>
    JSONApiService(commit)
      .all(ADDRESS_MODEL)
      .get({ ...params }),
  getReasonsForHire: organisationId => {
    const api = JSONApiService(commit).all(DATA);
    disablePluralizeForCall(api, () =>
      api.all(hireReasonEndpoints.REASONS_FOR_HIRE)
    );
    return api.get({ filter: { client_id: organisationId } });
  },
  getCountries: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(COUNTRY_MODEL)
      .get(),
  getFieldNecessities: params => {
    return JSONApiService(commit)
      .all(FIELD_NECESSITY_MODEL)
      .get({ ...params });
  },
  getPublishingScheduleTags: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(PUBLISHING_SCHEDULE_TAG)
      .get(),
  getTaxonomies: params =>
    JSONApiService(commit)
      .all(TAXONOMY_MODEL)
      .get(params),
  getCostCategories: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(COST_CATEGORY)
      .get(),
  getSexualOrientations: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(SEXUAL_ORIENTATION_MODEL)
      .get(),
  getReligions: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(RELIGION_MODEL)
      .get(),
  getMaritalStatuses: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(MARITAL_STATUS_MODEL)
      .get(),
  getLocationGroupings: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(LOCATION_GROUPING_MODEL)
      .get(),
  getEthnicGroups: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(ETHNIC_GROUP_MODEL)
      .get(include(CATEGORY)),
  getGrades: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(GRADE_MODEL)
      .get(),
  getWorkingHours: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(WORKING_HOURS_MODEL)
      .get(),
  getWorkingHoursGroupings: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(WORKING_HOURS_GROUPINGS)
      .get(),
  getFunctions: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(EXPERIENCE_FUNCTION_MODEL)
      .get(),
  getContractTypes: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(CONTRACT_TYPE_MODEL)
      .get(),
  getContractTypesGroupings: () =>
    JSONApiService(commit)
      .all(DATA)
      .all(CONTRACT_TYPES_GROUPINGS)
      .get(),
  addComment: async data => JSONApiService(commit).create(COMMENT_MODEL, data),
  addCommentFile: async (id, data) =>
    APIService.client().postFile(
      `${pluralize(COMMENT_MODEL)}/${id}/file`,
      data
    ),
  removeFile: async url => APIService.client().delete(url)
});

export default dataApi;
